import { Box, Media } from "@talentpair/quantic";
import * as React from "react";

interface BannerHeaderProps {
  isDesktop: boolean;
  title: React.ReactNode;
  actions?: React.ReactNode;
  maxWidth?: string;
  breadcrumbs?: React.ReactNode;
  centerBanner?: boolean;
}

const BaseBannerHeader = ({
  isDesktop = false,
  maxWidth = "max-width-4",
  title = "Talentpair",
  breadcrumbs = null,
  actions = null,
  centerBanner = false,
}: BannerHeaderProps): React.ReactElement => (
  <Box
    // background="grey.50"
    className={isDesktop ? "pt4 pb3 grey-border-bottom" : "px4 pt4 pb3 grey-border-bottom"}
    variant="column"
    layout="center-center"
    style={{ minHeight: 110, width: "100vw" }}
  >
    <Box
      space={3}
      layout={centerBanner ? "center-center" : "stretch-start"}
      variant="column"
      className={`${!isDesktop ? "col-12" : `col-8 ${maxWidth || "max-width-4"}`} mx-auto`}
    >
      {breadcrumbs && <div>{breadcrumbs}</div>}
      <Box variant="row" layout="center-between">
        <h1 className="h2 bold p0 m0">{title}</h1>
        {actions ? <span>{actions}</span> : null}
      </Box>
    </Box>
  </Box>
);

const BannerHeader = (props: Omit<BannerHeaderProps, "isDesktop">): React.ReactElement => (
  <Media>{(isDesktop: boolean) => <BaseBannerHeader {...props} isDesktop={isDesktop} />}</Media>
);

export default BannerHeader;

export const _test = { BaseBannerHeader };
